import angular from "angular";
import uiRouter from "angular-ui-router";
import routing from "./homeowner.routes";

const debug = require("debug")("fifi:homeowner");

export class HomeownerController {
  /*@ngInject*/
  constructor(Applications, $state, Auth, $stateParams) {
    debug("test");
    this._Applications = Applications;
    this._$state = $state;
    this._$stateParams = $stateParams;
    this.resetForm();
    debug(this.settings);
    if (!this.settings.enableOBHOForm && !Auth.isAdminSync()) {
      $state.go("main");
    }
    if ($stateParams.type && $stateParams.type == "OB HO") {
      this.headline = "Ocean Beach";
    }
    if ($stateParams.type && $stateParams.type == "SA HO") {
      this.headline = "Saltaire";
    }
  }

  submitForm(form) {
    debug(form);
    if (form.$valid) {
      let part1 = this.idPart1.replace(/ /g, "").toLowerCase();
      let part2 = this.idPart2.replace(/ /g, "").toLowerCase();
      let part3 = this.idPart3.replace(/ /g, "").toLowerCase();
      let id = `${part1}-${part2}-${part3}`;
      debug(id);
      this._Applications
        .homeowner({ id, zip: this.zip, type: this._$stateParams.type })
        .then(
          (response) => {
            debug(response);
            this.application = response;
            this.application.obOverride = true;
            this.application.history.push({
              sticker: this.application.sticker,
              year: this.application.year,
              notes: this.application.notes,
              status: this.application.sticker,
              payment: this.application.payment,
              charge: this.application.charge,
            });
            Reflect.deleteProperty(this.application, "sticker");
            Reflect.deleteProperty(this.application, "_id");
            Reflect.deleteProperty(this.application, "year");
            Reflect.deleteProperty(this.application, "status");
            Reflect.deleteProperty(this.application, "charge");
            Reflect.deleteProperty(this.application, "payment");
            Reflect.deleteProperty(this.application, "agreement");
            Reflect.deleteProperty(this.application, "timestamp");
            Reflect.deleteProperty(this.application, "__v");
            Reflect.deleteProperty(this.application, "active");
            this.application.failedAttempts = 0;
            debug(this.application);
          },
          (err) => {
            console.log(err);
            this.error = err.data.message;
            if (!err.data.message) {
              this.error = "Please check all information and try again.";
            }
          }
        );
    }
  }

  beginApplication() {
    if (this.application.homeownerId) {
      this._$state.go("application.contact", {
        homeownerApp: this.application,
      });
    } else {
      this.resetForm();
      this.error =
        "The application is invalid, please try again or contact us at 631-665-3600";
    }
  }

  resetForm() {
    this.application = null;
    this.error = null;
    this.idPart1 = null;
    this.idPart2 = null;
    this.idPart3 = null;
    this.zip = null;
  }
}

export default angular
  .module("parkingFormApp.homeowner", [uiRouter])
  .config(routing)
  .component("homeowner", {
    template: require("./homeowner.html"),
    controller: HomeownerController,
    controllerAs: "$homeowner",
    bindings: {
      settings: "<",
    },
  }).name;



// WEBPACK FOOTER //
// ./client/app/homeowner/homeowner.component.js